<template>
  <v-card class="">
    <div class="pa-3 headline font-weight-bold greyDarken3--text">
      {{ screener.title[currentLocale] }}
      <v-chip
        class="mx-0"
        small
        :color="screener.published ? 'success' : 'red'"
        outline
        >
        <v-tooltip v-if="screener.is_unlisted" top color="greyDarken1">
          <template v-slot:activator="{on}">
            <v-icon v-on="on" v-if="screener.is_unlisted" small class="pr-1 red--text">mdi-lock</v-icon>
          </template>
          <span class="white--text body-1">{{$t('screener.secret_event.tooltip')}}</span>
        </v-tooltip>
        {{
          screener.published
            ? $t('screener.save.form.published')
            : $t('screener.save.form.unpublished')
        }}</v-chip
      >
      <v-chip
        class="mx-2"
        v-if="!screener.is_vod_event"
        small
        :color="'primary'"
        outline
      >
        {{ DEFINES.SCREENER_TYPE_STR[screener.event_type] }}
      </v-chip>
    </div>
    <v-layout class="ml-3 " v-if="consumers" row wrap>
      <v-flex class="mt-1" v-if="!screener.is_vod_event" xs12 sm12 md4>
        <div class="pa-2">
          <v-card class="mx-auto">
            <v-card dark>
              <v-img
                :src="
                  screener.thumbnail_url
                    ? screener.thumbnail_url
                    : screener.films[0]
                    ? screener.films[0].thumburls
                    : ''
                "
                gradient="to top, rgba(0,0,0,.44), rgba(0,0,0,.44)"
                max-height="270px"
                contain
              >
                <v-container fill-height>
                  <v-layout align-center>
                    <strong class="display-4 font-weight-regular mr-4">{{
                      moment.utc(screener.screening_starts_at).format('D')
                    }}</strong>
                    <v-layout column justify-end>
                      <div class="headline font-weight-light">
                        {{
                          moment
                            .utc(screener.screening_starts_at)
                            .format('dddd')
                        }}
                      </div>
                      <div class="text-uppercase font-weight-light">
                        {{
                          moment
                            .utc(screener.screening_starts_at)
                            .format('MMMM YYYY, h:mm:ss a')
                        }}
                      </div>
                    </v-layout>
                  </v-layout>
                </v-container>
              </v-img>
            </v-card>
            <v-card-text class="py-0">
              <v-timeline dense align-top>
                <v-timeline-item
                  v-for="(timeline, index) in valid_timelines"
                  :key="index + 1"
                  :color="timeline.color"
                  small
                >
                  <v-layout row wrap pt-2>
                    <v-flex xs10 md10>
                      <v-layout row wrap>
                        <v-flex xs12 md12>
                          <strong :class="`${timeline.color}--text`">{{
                            timeline.string
                          }}</strong>
                        </v-flex>
                        <v-flex xs12 md12>
                          <strong>{{
                            moment
                              .utc(timeline.timestamp)
                              .format('dddd, MMMM Do YYYY, h:mm a')
                          }}</strong>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs2 md2>
                      <v-tooltip top color="white">
                        <template v-slot:activator="{on, attrs}">
                          <v-btn
                            color="success"
                            v-bind="attrs"
                            v-on="on"
                            fab
                            dark
                            small
                            @click="copyRegistrationUrl()"
                            v-if="
                              timeline.string ==
                                $t(
                                  'screener.save.overview.section.screening_timelines.registration_start_time'
                                )
                            "
                            ><v-icon small
                              >$vuetify.icons.rms_copy</v-icon
                            ></v-btn
                          >
                        </template>
                        <div
                          class="grey--text text--darken-3 body-1"
                          v-html="
                            $t(
                              'screener.save.form.registration_link_copy_tooltip'
                            )
                          "
                        >
                          {{
                            $t(
                              'screener.save.form.registration_link_copy_tooltip'
                            )
                          }}
                        </div>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-timeline-item>
              </v-timeline>
            </v-card-text>
          </v-card>
        </div>
      </v-flex>
      <v-flex xs12 sm12 :class="[screener.is_vod_event ? 'md12' : 'md8']">
        <!-- Virtual Event Overview -->
        <v-flex xs12 md12 sm12>
          <v-layout v-if="isPhysicalEvent(false)">
            <v-flex mx-3>
              <v-card flat>
                <v-card-title
                  class="title font-weight-bold"
                  v-if="!screener.is_vod_event"
                  >{{ $t('sceener.save.overview.virtual_event') }}</v-card-title
                >
                <v-divider v-if="!screener.is_vod_event" />
                <div class="pl-3 greyBackground">
                  <v-layout class="pt-4">
                    <v-flex xs12 sm12 md12 px-3 mt-2>
                      <div class="subheadline pb-2 font-weight-black">
                        <span
                          v-if="
                            screener.id != undefined && screener.is_vod_event
                          "
                          >{{
                            $t('screener.save.overview.section.vod_statistics')
                          }}</span
                        >
                        <span v-else>{{
                          $t(
                            'screener.save.overview.section.virtual_registration_statistics'
                          )
                        }}</span>
                      </div>
                      <v-layout
                        row
                        wrap
                        v-if="screener.id != undefined && screener.is_vod_event"
                      >
                        <v-text-field
                          outline
                          id="vod_rent_link"
                          :label="$t('screener.save.form.rent_link')"
                          name="vod_rent_link"
                          readonly
                          color="primary"
                          append-icon="$vuetify.icons.rms_copy"
                          type="text"
                          @click:append="copyRegistrationUrl()"
                          :value="registrationLink()"
                        ></v-text-field>
                      </v-layout>
                      <v-card>
                        <v-layout row wrap>
                          <v-flex
                            v-if="!screener.is_vod_event"
                            xs12
                            sm12
                            md6
                            pa-2
                          >
                            <v-card flat class="pa-3">
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-tooltip top color="greyDarken1">
                                    <template v-slot:activator="{on}">
                                      <div
                                        v-on="on"
                                        class="headline text-xs-center"
                                      >
                                        {{
                                          screener.num_of_enrollments
                                        }}&nbsp;/&nbsp;{{ screener.limitation }}
                                      </div>
                                    </template>
                                    <span class="white--text body-1">{{
                                      $t('screener.total_registrants.tooltip')
                                    }}</span>
                                  </v-tooltip>
                                  <div
                                    class="
                                  subheading
                                  saSecondary--text
                                  text-xs-center
                                "
                                  >
                                    {{ $t('screener.save.form.seats') }}
                                  </div>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm12 md3 pa-2>
                            <v-card flat class="pa-3">
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <div class="headline text-xs-center">
                                    {{ consumers.total }}
                                  </div>
                                  <div
                                    class="
                                  subheading
                                  saSecondary--text
                                  text-xs-center
                                "
                                  >
                                    <span v-if="screener.is_vod_event">{{
                                      $t('screener.admin.total_participants')
                                    }}</span>
                                    <span v-else>
                                      {{
                                        $t(
                                          'screener.save.overview.section.registration_statistics.total_registration'
                                        )
                                      }}</span
                                    >
                                  </div>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm12 md3 pa-2>
                            <v-card flat class="pa-3">
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <div class="headline text-xs-center">
                                    {{ screening_attended_count }}
                                  </div>
                                  <div
                                    class="
                                  subheading
                                  saSecondary--text
                                  text-xs-center
                                "
                                  >
                                    {{
                                      $t('screener.admin.screening_attended')
                                    }}
                                  </div>
                                </v-flex>
                              </v-layout>
                            </v-card></v-flex
                          >
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex v-if="!screener.is_vod_event" xs12 sm12 md6 pa-3>
                      <div class="subheadline pb-2 font-weight-black">
                        {{ $t('screener.budget_spent.title') }}
                      </div>
                      <v-card class="pa-3">
                        <div class="headline text-xs-center">
                          <template
                            v-if="
                              screener.screening_type !==
                                DEFINES.SCREENING_PLAN_TYPE.ENTERPRISE
                            "
                          >
                            {{ DEFINES.PREMIUM_SCREENING_BASE_CURRENCY_SYMBOL
                            }}{{
                              _calculatePaidAmount(screener)
                            }}&nbsp;/&nbsp;{{
                              DEFINES.PREMIUM_SCREENING_BASE_CURRENCY_SYMBOL
                            }}{{ _calculateTotalBudget(screener) }}
                          </template>
                          <template v-else><span>NA</span></template>
                        </div>
                        <div
                          class="subheading saSecondary--text text-xs-center"
                        >
                          {{ $t('screener.budget_spent.title') }}
                        </div>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm12 md6 pa-3>
                      <div class="subheadline pb-2 font-weight-black">
                        {{
                          $t(
                            'screener.save.overview.section.monetization_statistics'
                          )
                        }}
                      </div>
                      <v-card class="pa-2">
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md6 pa-2>
                            <v-card flat class="px-2">
                              <div class="headline text-xs-center">
                                <span
                                  v-if="screener.monetization_enabled"
                                  class="success--text"
                                  >{{
                                    $t(
                                      'screener.save.overview.section.monetization_statistics.status.active'
                                    )
                                  }}</span
                                >
                                <span v-else>NA</span>
                              </div>
                              <div
                                class="
                                  subheading
                                  saSecondary--text
                                  text-xs-center
                                "
                              >
                                {{
                                  $t(
                                    'screener.save.overview.section.monetization_statistics.status'
                                  )
                                }}
                              </div>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm12 md6 pa-2>
                            <v-card flat class="px-2">
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <div class="headline text-xs-center">
                                    <span
                                      v-if="screener.monetization_enabled"
                                      class="success--text"
                                      >{{ screener.total_revenue }}</span
                                    >
                                    <span v-else>NA</span>
                                  </div>
                                  <div
                                    class="
                                  subheading
                                  saSecondary--text
                                  text-xs-center
                                "
                                  >
                                    {{
                                      $t(
                                        'screener.save.overview.section.monetization_statistics.total_revenue'
                                      )
                                    }}
                                    ({{ selected_company.currency }})
                                  </div>
                                </v-flex>
                              </v-layout>
                            </v-card></v-flex
                          >
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex v-if="!screener.is_vod_event" xs12 sm12 md6 pa-3>
                      <div class="subheadline pb-2 font-weight-black">
                        {{
                          $t(
                            'screener.save.overview.section.magic_link_statistics'
                          )
                        }}
                      </div>
                      <v-card class="pa-2">
                        <v-card-actions
                          v-if="magic_link_url && !screener.is_vod_event"
                        >
                          <v-btn
                            class="mr-5"
                            @click="copyMagicLink()"
                            absolute
                            top
                            color="primary"
                            right
                            small
                            fab
                          >
                            <v-icon>$vuetify.icons.rms_copy</v-icon>
                          </v-btn>
                          <v-btn
                            @click="magickLinkDialog = true"
                            absolute
                            top
                            color="primary"
                            right
                            small
                            fab
                          >
                            <v-icon>$vuetify.icons.rms_edit</v-icon>
                          </v-btn>
                        </v-card-actions>
                        <AccessLink
                          v-if="
                            !screener.monetization_enabled &&
                              !screener.is_vod_event
                          "
                          :editorDialog.sync="magickLinkDialog"
                          :screener="screener"
                          :company="selected_company"
                        ></AccessLink>
                        <div v-else>
                          <v-container
                            bg
                            fill-height
                            grid-list-md
                            text-xs-center
                          >
                            <v-layout row wrap align-center>
                              <v-flex>
                                <span class="grey--text">{{
                                  $t(
                                    'screener.save.overview.section.magic_link_statistics.not_available'
                                  )
                                }}</span>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </div>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm12 md4 pa-3>
                      <div class="subheadline pb-2 font-weight-black">
                        {{ $t('screener.save.geo_blocking') }}
                      </div>
                      <v-card class="pa-3">
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12 pa-2>
                            <v-card flat>
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <div class="headline text-xs-center">
                                    <span
                                      v-if="screener.geo_blocking.blocking_type"
                                      class="success--text"
                                      >Enabled</span
                                    >
                                    <span v-else>NA</span>
                                  </div>
                                  <div
                                    class="
                                  subheading
                                  saSecondary--text
                                  text-xs-center
                                "
                                  >
                                    {{
                                      $t(
                                        'screener.save.overview.section.geo_restriction.status'
                                      )
                                    }}
                                  </div>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <!-- Physical Event Overview -->
        <v-flex xs12 md12 sm12>
          <v-layout v-if="!screener.is_vod_event && isPhysicalEvent(true)">
            <v-flex ma-3>
              <v-card flat>
                <v-card-title class="title font-weight-bold">{{
                  $t('sceener.save.overview.in_venue_event')
                }}</v-card-title>
                <v-divider />
                <v-layout class="pb-3 pt-4 pl-3 greyBackground">
                  <v-flex px-3 mt-2>
                    <div class="subheadline pb-2 font-weight-black">
                      <span>{{
                        $t(
                          'screener.save.overview.section.physical_registration_statistics'
                        )
                      }}</span>
                    </div>
                    <v-card>
                      <v-layout row wrap>
                        <v-flex
                          v-if="!screener.is_vod_event"
                          xs12
                          sm12
                          md6
                          pa-2
                        >
                          <v-card flat class="pa-3">
                            <v-layout row wrap>
                              <v-flex xs12>
                                <v-tooltip top color="greyDarken1">
                                  <template v-slot:activator="{on}">
                                    <div
                                      v-on="on"
                                      class="headline text-xs-center"
                                    >
                                      {{
                                        _countSeatsWithStatus(
                                          DEFINES.SEATS_STATUS['BOOKED']
                                        )
                                      }}&nbsp;/&nbsp; {{ _countTotalSeats() }}
                                    </div>
                                  </template>
                                  <span class="white--text body-1">{{
                                    $t('screener.total_registrants.tooltip')
                                  }}</span>
                                </v-tooltip>
                                <div
                                  class="
                                  subheading
                                  saSecondary--text
                                  text-xs-center
                                "
                                >
                                  {{ $t('screener.save.form.seats') }}
                                </div>
                              </v-flex>
                            </v-layout>
                          </v-card>
                        </v-flex>
                        <v-flex xs12 sm12 md3 pa-2>
                          <v-card flat class="pa-3">
                            <v-layout row wrap>
                              <v-flex xs12>
                                <div class="headline text-xs-center">
                                  {{
                                    _countSeatsWithStatus(
                                      DEFINES.SEATS_STATUS['BOOKED']
                                    )
                                  }}
                                </div>
                                <div
                                  class="
                                  subheading
                                  saSecondary--text
                                  text-xs-center
                                "
                                >
                                  <span>
                                    {{
                                      $t(
                                        'screener.seats.statistics.stats_booked_seats'
                                      )
                                    }}</span
                                  >
                                </div>
                              </v-flex>
                            </v-layout>
                          </v-card>
                        </v-flex>
                        <v-flex xs12 sm12 md3 pa-2>
                          <v-card flat class="pa-3">
                            <v-layout row wrap>
                              <v-flex xs12>
                                <div class="headline text-xs-center">
                                  {{ total_attendees }}
                                </div>
                                <div
                                  class="
                                  subheading
                                  saSecondary--text
                                  text-xs-center
                                "
                                >
                                  {{ $t('screener.admin.screening_attended') }}
                                </div>
                              </v-flex>
                            </v-layout>
                          </v-card></v-flex
                        >
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <!-------------- Transactions ------------------>
        <v-layout
          row
          wrap
          v-if="
            screener.screening_type !==
              DEFINES.SCREENING_PLAN_TYPE.ENTERPRISE && transactions.length
          "
        >
          <v-flex xs12 pa-3>
            <div class="subheadline pb-2 font-weight-black">
              Payment Transactions
            </div>

            <v-data-table
              :headers="headers"
              :items="transactions"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <tr>
                  <td>
                    {{
                      $t(
                        'payment_transaction.charged_for.' + props.item.txn_type
                      )
                    }}
                  </td>
                  <td>{{ props.item.currency }}</td>
                  <td>
                    {{ getCurrencySymbol(props.item.currency)
                    }}{{ props.item.total_amount }}
                  </td>
                  <td>
                    <span v-if="props.item.gateway_fee > 0" class="red--text"
                      ><strong>-&nbsp;</strong></span
                    >{{ getCurrencySymbol(props.item.currency)
                    }}{{ props.item.gateway_fee }}
                  </td>
                  <td>{{ props.item.txn_status | capitalize }}</td>
                  <td>
                    <v-icon v-if="props.item.is_paid" color="success"
                      >mdi-check</v-icon
                    >
                    <v-icon v-else color="error">mdi-window-close</v-icon>
                  </td>
                  <td>
                    <v-tooltip slot="append" top color="white">
                      <v-chip
                        slot="activator"
                        outline
                        color="secondary"
                        class="white--text cursor-pointer"
                        small
                        @click.stop="viewReceipt(props.item.receipt_url)"
                      >
                        <strong>Download</strong>
                        <v-icon>mdi-download</v-icon>
                      </v-chip>
                      <span class="greyDarken3--text body-1">
                        Click to download the receipt
                      </span>
                    </v-tooltip>
                  </td>
                  <td>
                    {{
                      moment
                        .utc(props.item.created_at)
                        .format('Do MMM YYYY, h:mm a')
                    }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
        <!-- Analytics -->
        <v-layout row wrap>
          <v-flex xs12 sm12 md12 pa-2>
            <div class="subheadline pb-2 font-weight-black">
              {{ $t('screener.avails.analytics.heading') }}
            </div>
            <v-card class="pa-2">
              <v-layout class="pt-4">
                    <v-flex xs12 sm12 md12 px-3 mt-2>
                       <div class="subheadline pb-2 font-weight-black">
                        <span>{{
                            $t('screener.avails.analytics.subheading')
                          }}
                        </span>
                      </div>
                      <v-card>
                        <v-layout row wrap>
                          <v-flex
                            xs12
                            sm12
                            md4
                            pa-2
                          >
                            <v-card flat class="pa-3">
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-tooltip top color="greyDarken1">
                                    <template v-slot:activator="{on}">
                                      <div
                                        v-on="on"
                                        class="headline text-xs-center"
                                      >
                                        {{
                                          analytics?analytics.hour.users:0
                                        }}
                                        <!-- &nbsp;/&nbsp;{{ consumers.total }} -->
                                      </div>
                                    </template>
                                    <span class="white--text body-1">{{
                                      $t('screener.overview.analytics.hour.tooltip')
                                    }}</span>
                                  </v-tooltip>
                                  <div
                                    class="
                                  subheading
                                  saSecondary--text
                                  text-xs-center
                                "
                                  >
                                    {{ $t('screener.overview.analytics.hour') }}
                                  </div>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex
                            xs12
                            sm12
                            md4
                            pa-2
                          >
                            <v-card flat class="pa-3">
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-tooltip top color="greyDarken1">
                                    <template v-slot:activator="{on}">
                                      <div
                                        v-on="on"
                                        class="headline text-xs-center"
                                      >
                                        {{
                                          analytics?analytics.today.users:0
                                        }}
                                        <!-- &nbsp;/&nbsp;{{ consumers.total }} -->
                                      </div>
                                    </template>
                                    <span class="white--text body-1">{{
                                      $t('screener.overview.analytics.today.tooltip')
                                    }}</span>
                                  </v-tooltip>
                                  <div
                                    class="
                                  subheading
                                  saSecondary--text
                                  text-xs-center
                                "
                                  >
                                    {{ $t('screener.overview.analytics.today') }}
                                  </div>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex
                            xs12
                            sm12
                            md4
                            pa-2
                          >
                            <v-card flat class="pa-3">
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-tooltip top color="greyDarken1">
                                    <template v-slot:activator="{on}">
                                      <div
                                        v-on="on"
                                        class="headline text-xs-center"
                                      >
                                        {{
                                          analytics?analytics.total.users:0
                                        }}
                                        <!-- &nbsp;/&nbsp;{{ consumers.total }} -->
                                      </div>
                                    </template>
                                    <span class="white--text body-1">{{
                                      $t('screener.overview.analytics.total.tooltip')
                                    }}</span>
                                  </v-tooltip>
                                  <div
                                    class="
                                  subheading
                                  saSecondary--text
                                  text-xs-center
                                "
                                  >
                                    {{ $t('screener.overview.analytics.total') }}
                                  </div>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
              <v-card-text class="text-xs-center text-md-center">
                <div class="pa-2">
                  <v-btn
                    color="primary"
                    dark
                    @click="
                      $router.push({
                        name: 'analytics.index',
                        params: {
                          screening: screener,
                        },
                      })
                    "
                    >{{ $t('screener.avails.event.analytics') }}</v-btn
                  >
                </div>
              </v-card-text>
              <v-card-text>
                <h4>{{ $t('screener.avails.label.film.analytics') }}</h4>
                <div
                  class="pa-2 text-xs-center text-md-center"
                  v-for="(film, index) in screener.films"
                  :key="index"
                >
                  <v-btn
                    @click="
                      $router.push({
                        name: 'analytics.index',
                        params: {
                          selectedFilm: film,
                          selectedTab: 'film_wise',
                        },
                      })
                    "
                    >{{ film.title[currentLocale] }}</v-btn
                  >
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <!-- Analytics -->
      </v-flex>
      <!-- Organizations -->
    </v-layout>
    <div class="pa-4"></div>
  </v-card>
</template>
<script>
import AccessLink from '@/pages/screener/AccessLink';
import {mapState, mapGetters} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import {utcToTz, tzToUtc, calDateToMin, calMinToDate} from '@/helper';
import moment from 'moment';
import DEFINES from '@/defines';
import i18n from '@/i18n';

import {_calculatePaidAmount, _calculateTotalBudget} from '@/mixins/screening';
import {getCurrencySymbol} from '@/helper';

export default {
  name: 'ScreenerOverview',
  props: {
    screener: {
      type: Object,
      default: null,
    },
    seatsStatus: {
      type: Object,
      default: null,
    },
    total_attendees: {
      type: Number,
      default: null,
    },
  },
  components: {
    AccessLink,
  },
  mixins: [_calculatePaidAmount, _calculateTotalBudget],
  data() {
    return {
      consumers: [],
      moment,
      calMinToDate,
      screening_attended_count: null,
      total_purchased_count: null,
      total_enrolled_count: null,
      magickLinkDialog: false,
      valid_timelines: [],
      timelines: [
        {
          timestamp: this.screener.screening_starts_at,
          string: i18n.t(
            'screener.save.overview.section.screening_timelines.screening_start_time'
          ),
          color: 'primary',
        },
        {
          timestamp: this.screener.screening_ends_at,
          string: i18n.t(
            'screener.save.overview.section.screening_timelines.screening_end_time'
          ),
          color: 'primary',
        },
        {
          timestamp: this.screener.registration_starts_at,
          string: i18n.t(
            'screener.save.overview.section.screening_timelines.registration_start_time'
          ),
          color: 'success',
        },
        {
          timestamp: this.screener.registration_ends_at,
          string: i18n.t(
            'screener.save.overview.section.screening_timelines.registration_end_time'
          ),
          color: 'success',
        },
        {
          timestamp: this.screener.screening_tolerance,
          string: i18n.t(
            'screener.save.overview.section.screening_timelines.tolerance_time'
          ),
          color: 'error',
        },
      ],
      headers: [
        {
          text: 'Charged For',
          align: 'left',
          sortable: false,
          value: 'txn_type',
        },
        {text: 'Currency', align: 'left', sortable: false, value: 'currency'},
        {
          text: 'Total Amount',
          align: 'left',
          sortable: false,
          value: 'total_amount',
        },
        {
          text: 'Gateway Fee',
          align: 'left',
          sortable: false,
          value: 'gateway_fee',
        },
        {text: 'Status', align: 'left', sortable: false, value: 'txn_status'},
        {text: 'Paid', align: 'left', sortable: false, value: 'is_paid'},
        {
          text: 'Receipt',
          align: 'left',
          sortable: false,
          value: 'receipt_url',
        },
        {
          text: 'Created At',
          align: 'left',
          sortable: false,
          value: 'created_at',
        },
      ],
      transactions: [],
      analytics :null
    };
  },
  created() {
    if (this.$route.params.screener_id != undefined) {
      this.getDataFromApi();
      this.getScreeningTransactions();
    }
  },
  computed: {
    ...mapGetters('company', {
      selected_company: 'getSelectedCompany',
    }),
    ...mapFields('screenerAccessLink', {
      magicLink: 'magic_link',
    }),
    magic_link_url() {
      var URL = null;
      if(!this.magicLink){
        return URL;
      }
      URL = `${this.selected_company.domain}/screeners/${this.$route.params.screener_id}/link/${this.magicLink.id}?mode=anonymous`;
      if(this.screener.is_unlisted){
        URL += '&rel=nofollow';
      }
      return URL;
    },
    ...mapGetters('company', {
      timezone: 'getSelectedCompanyTimezone',
    }),
    currentLocale() {
      return this.$i18n.locale;
    }
  },
  mounted() {
    this.sortTimelines();
    this.fetchAnalyticsOverview();
  },
  methods: {
    viewReceipt(receipt_url) {
      if (receipt_url) {
        window.open(receipt_url);
      }
    },
    getCurrencySymbol(currency) {
      return getCurrencySymbol(currency);
    },
    async getDataFromApi() {
      try {
        var result = await this.$store.dispatch('consumer/getConsumerList', {
          screener_id: this.$route.params.screener_id,
        });
        this.consumers = result.consumers;
        this.screening_attended_count = result.screening_attended_count;
        this.total_purchased_count = result.total_purchased_count;
        this.total_enrolled_count = result.total_enrolled_count;
      } catch (error) {
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      }
    },
    async getScreeningTransactions() {
      try {
        var response = await this.$store.dispatch(
          'screener/listPaymentTransactions',
          {
            screener_id: this.$route.params.screener_id,
          }
        );
        this.transactions = response.transactions;
      } catch (error) {
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      }
    },
    registrationLink() {
      if (this.selected_company && this.screener.id) {
        return `${this.selected_company.domain}/screeners/${this.screener.id}`;
      }
    },

    async getMagicLink() {
      await this.$store
        .dispatch('screenerAccessLink/getMagicLink', {
          screener_id: this.$route.params.screener_id,
        })
        .then((response) => {
          if (response.magic_link) {
            var uuid = response.magic_link.id;
            this.magic_link_url = `${this.selected_company.domain}/screeners/${this.$route.params.screener_id}/link/${uuid}`;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },

    async copyRegistrationUrl() {
      this.$copyText(this.registrationLink());
      this.$store.dispatch('app/showMessage', {
        message: 'URL copied successfully',
        color: this.DEFINES.SNACKBAR_SUCCESS_COLOR,
      });
    },

    async copyMagicLink() {
      this.$copyText(this.magic_link_url);
      this.$store.dispatch('app/showMessage', {
        message: 'Magic link copied successfully',
        color: this.DEFINES.SNACKBAR_SUCCESS_COLOR,
      });
    },

    async sortTimelines() {
      this.timelines.sort(function(a, b) {
        return new Date(a.timestamp) - new Date(b.timestamp);
      });
      this.valid_timelines = this.timelines.filter(
        (item) => item.timestamp != null
      );
    },

    _countSeatsWithStatus(status) {
      if (!this.seatsStatus) {
        return 'N/A';
      }
      return Object.keys(this.seatsStatus).reduce((count, key) => {
        if (
          this.seatsStatus[key]['status'] == status &&
          this.screener.physical_venue.seats[key].is_accessible
        ) {
          return (count += 1);
        }
        return count;
      }, 0);
    },

    _countTotalSeats() {
      if (!this.screener.physical_venue) {
        return 'N/A';
      }
      return Object.keys(this.screener.physical_venue.seats).reduce(
        (count, key) => {
          return this.screener.physical_venue.seats[key].is_accessible
            ? (count += 1)
            : count;
        },
        0
      );
    },

    isPhysicalEvent(physical_event) {
      if (physical_event) {
        return (
          this.screener.event_type == DEFINES.SCREENER_TYPE.PHYSICAL ||
          this.screener.event_type == DEFINES.SCREENER_TYPE.VIRTUAL_AND_PHYSICAL
        );
      } else {
        return (
          this.screener.event_type != DEFINES.SCREENER_TYPE.PHYSICAL ||
          this.screener.event_type == DEFINES.SCREENER_TYPE.VIRTUAL_AND_PHYSICAL
        );
      }
    },

    async fetchAnalyticsOverview() {
      try {
        var result = await this.$store.dispatch(
          'analytics/fetchEntityOverviewData',
          {
            entity_id: this.$route.params.screener_id,
            entity_type: 'event',
            timezone: this.timezone,
          }
        );
        this.analytics = result.analytics;
      } catch (error) {
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      }
    },
  },
};
</script>
<style scoped>
.greyBackground {
  background: #f9f9f9;
}
</style>
